export default {"src":"/_next/static/media/ic-open-question.57a31269.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};